module.exports = __webpack_public_path__ + "img/tablet-landscape.5a788ea1.svg";